import React, { Component, createRef } from "react";

import "../assets/styles/Home.scss";
import "../assets/styles/font.scss";
import formBanner from "../assets/images/form-banner.jpg";
import scrollToTop from "../assets/images/icons/scrollToTop.svg";

import stepIconForm from "../assets/images/step-1-icon.png";
import stepIconOutlet from "../assets/images/step-2-icon.png";
import stepIconRoche from "../assets/images/step-3-icon.svg";
import stepIconBookdoc from "../assets/images/step-4-icon.png";
import stepIconMog from "../assets/images/step-5-icon.svg";
import programmeInfoImg from "../assets/images/programme-info.png";
import programmeInfoImgMobile from "../assets/images/programme-info-small.png";
import diabetesFactImg from "../assets/images/diabetes-fact-infographic.png";

import bookdocLogo from "../assets/images/bookdoc-logo.svg";
import sunlifeBizLogo from "../assets/images/sunlife-biz-logo.svg";
import healthlaneLogo from "../assets/images/healthlane-logo.svg";
import mogLogo from "../assets/images/mog-logo.svg";
import rocheLogo from "../assets/images/roche-logo.svg";

import bookdocLogoMobile from "../assets/images/bookdoc-logo-mobile.svg";
import healthlaneLogoMobile from "../assets/images/healthlane-logo-mobile.svg";
import mogLogoMobile from "../assets/images/mog-logo-mobile.svg";
import rocheLogoMobile from "../assets/images/roche-logo-mobile.svg";

import Tnc from "assets/files/Terms_of_Use_for_SLM_Blood_Glucose_Screening_Prog_2026.pdf";

import RegistrationClosedModal from "./RegistrationClosedModal";
import RegistrationSuccessModal from "./RegistrationSuccessModal";
import Faq from "./Faq";

import { apiService } from "../services/api";
import { questionnaire } from "constants/questionnaire";
import { PROGRAM_CLOSE_DATE } from "constants/schedule";

import {
  Form,
  Button,
  InputGroup,
  FormControl,
  Spinner,
} from "react-bootstrap";
import "../modules/global";
import Select, { components } from "react-select";
import { Formik, ErrorMessage, Field } from "formik";
import * as yup from "yup";
import moment from "moment";

import ReCAPTCHA from "react-google-recaptcha";

class Home extends Component {
  constructor(props) {
    super(props);

    this._reCaptchaRef = createRef();
    this.formActions = createRef();

    this.base_user = {
      name: "",
      age: "",
      email: "",
      country_code: {
        label: "Malaysia (+60)",
        value: "+60",
        full: {
          code: "MY",
          dial_code: "+60",
          name: "Malaysia",
        },
      },
      phone_number: "",
      gender: "",
      state: "",
      terms: false,
      healthlane_preferred_store: "",
      healthlane_booked_date: "",
      answer_1: "",
      answer_2: "",
      answer_3: "",
    };

    this.state = {
      countries: global.constant.countries.map((country) => ({
        label: `${country.name} (${country.dial_code})`,
        value: country.dial_code,
        full: country,
      })),
      states: [],
      healthlane_stores: [],
      _healthlane_stores: [],
      healthlane_preferred_dates: [],
      user: this.base_user,
      registry: {},
      formErrors: [],
      token: "",
      maxDate: moment().format("YYYY-MM-DD"),
      step: 1,
      hideDiv: false,
      validatingPhone: false,
      showSuccessModal: false,
    };
  }

  componentDidMount() {
    this.displayButton();
    this.getHealthlaneStatesAndStores();
    this.scheduleHide();
  }

  scheduleHide = () => {
    const now = new Date();
    const timeUntilHide = PROGRAM_CLOSE_DATE - now;
    const MAX_TIMEOUT = 2147483647; // setTimeout max (~24.8 days)

    if (timeUntilHide <= 0) {
      this.setState({ hideDiv: true });
    } else if (timeUntilHide <= MAX_TIMEOUT) {
      this.timer = setTimeout(() => {
        this.setState({ hideDiv: true });
      }, timeUntilHide);
    }
    // else: close date is far in the future — do nothing until next page load
  };

  validationSchemaStep1 = yup.object().shape({
    name: yup
      .string()
      .required()
      .max(100)
      .matches(/^[^0-9]*$/, "Invalid name")
      .label("Name"),
    age: yup.object().required().label("Age"),
    phone_number: yup
      .string()
      .required()
      .min(8, "Phone number is invalid")
      .max(15, "Phone number is invalid")
      .matches("^[0-9]*$", "Phone number is invalid")
      .label("Phone number"),
    email: yup.string().email().required().max(50).label("Email"),
    state: yup.object().required().label("State"),
  });

  validationSchemaStep2 = yup.object().shape({
    healthlane_preferred_store: yup
      .object()
      .required()
      .label("Preferred store"),
    healthlane_booked_date: yup.object().required().label("Appointment date"),
  });

  validationSchemaStep3 = yup.object().shape({
    answer_1: yup.object().required("Required field."),
    answer_2: yup.object().required("Required field."),
    terms: yup
      .bool()
      .oneOf(
        [true],
        "Please tick to agree on the terms and conditions to continue",
      ),
  });

  getValidationSchema = () => {
    switch (this.state.step) {
      case 1:
        return this.validationSchemaStep1;
      case 2:
        return this.validationSchemaStep2;
      case 3:
        return this.validationSchemaStep3;
      default:
        return null;
    }
  };

  displayButton() {
    window.addEventListener("scroll", () => {
      const toTop = document.getElementById("scroll-to-top");

      if (window.scrollY > 100) {
        toTop.style.display = "block";
      } else {
        toTop.style.display = "none";
      }
    });
  }

  getHealthlaneStatesAndStores() {
    apiService.stores("healthlane").then(
      (response) => {
        if (response) {
          this.setState({
            states: response.states.map((option) => ({
              value: option.id,
              label: option.name,
            })),
            _healthlane_stores: response.stores,
          });
        }
      },
      (error) => {
        this.setState({ error, loading: false });
      },
    );
  }

  handleRegistration(formData, actions) {
    this.formActions = actions;
    this.setState(
      (prevState) => ({
        registry: {
          ...prevState.registry,
          name: formData.name,
          age: formData.age.value,
          email: formData.email,
          phone_number: `${formData.country_code.value.replace(/[+-]/g, "")}${
            formData.phone_number
          }`,
          gender: formData.gender.value,
          state_id: formData.state.value,
          healthlane_preferred_store: formData.healthlane_preferred_store.value,
          healthlane_booked_date: formData.healthlane_booked_date.value,
          answer_1: formData.answer_1.value,
          answer_2: formData?.answer_2?.value,
          answer_3: Array.isArray(formData?.answer_3)
            ? formData.answer_3.map((o) => o.value).join(",")
            : formData?.answer_3?.value,
          type: "sunlife",
        },
      }),
      () => {
        this.state.token
          ? this.registration()
          : this._reCaptchaRef.current.execute();
      },
    );
  }

  registration() {
    let submitBtn = document.getElementById("submit-btn");
    let submitSpinner = document.getElementById("submit-spinner");
    submitBtn.classList.add("disabled");
    submitSpinner.classList.remove("d-none");

    this.setState((prevState) => ({
      registry: {
        ...prevState.registry,
        token: this.state.token,
      },
    }));

    apiService.registration(this.state.registry).then(
      (response) => {
        this._reCaptchaRef.current.reset();
        if (response.hasOwnProperty("errors")) {
          this.setState({
            formErrors: response.errors,
            token: null,
          });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.setState({ showSuccessModal: true });
          this.formActions.resetForm({
            user: this.base_user,
          });
          this.setState({
            formErrors: [],
            stores: [],
            token: null,
            step: 1,
          });
        }
        submitBtn.classList.remove("disabled");
        submitSpinner.classList.add("d-none");
      },
      (error) => {
        this.setState({ error, loading: false });
      },
    );
  }

  onStateChange(selected, FieldProps) {
    let healthlane_filtered = [
      {
        label: selected.label,
        options: this.state._healthlane_stores
          .filter(
            (healthlane_store) => healthlane_store.state_id === selected.value,
          )
          .map((option) => ({
            value: option.id,
            label: option.name,
          })),
      },
    ];

    this.setState({
      healthlane_stores: healthlane_filtered,
    });
    FieldProps.form.setFieldValue("healthlane_preferred_store", "");
    FieldProps.form.setFieldValue("healthlane_booked_date", "");
    FieldProps.form.setFieldValue(FieldProps.field.name, selected);
  }

  onHealthlaneStoreChange(selected, FieldProps) {
    apiService.dateSlots(selected.value, "healthlane").then(
      (response) => {
        if (response) {
          let filtered = [
            {
              label: selected.label,
              options: response.dates.map((option) => ({
                value: option.date,
                label: option.message,
              })),
            },
          ];

          this.setState({
            healthlane_preferred_dates: filtered,
          });

          FieldProps.form.setFieldValue("healthlane_booked_date", "");
          FieldProps.form.setFieldValue(FieldProps.field.name, selected);
        }
      },
      (error) => {
        this.setState({ error, loading: false });
      },
    );
  }

  handleTokenChange = (value) => {
    this.setState({ token: value });
    if (value === null) {
      this.setState({
        formErrors: ["Token expired. Please refresh the page and try again"],
      });
    } else {
      this.registration();
    }
  };

  goNextStep = () => {
    this.setState((prev) => ({ step: Math.min(prev.step + 1, 3) }));
  };

  goPrevStep = () => {
    this.setState((prev) => ({ step: Math.max(prev.step - 1, 1) }));
  };

  handleNextClick = async (values, setTouched, setErrors) => {
    const schema = this.getValidationSchema();

    try {
      await schema.validate(values, { abortEarly: false });
    } catch (err) {
      const errors = {};
      const touched = {};

      err.inner.forEach((e) => {
        if (!errors[e.path]) {
          errors[e.path] = e.message;
          touched[e.path] = true;
        }
      });

      setErrors(errors);
      setTouched(touched);
      return;
    }

    if (this.state.step === 1) {
      const phoneNumber = `${values.country_code.value.replace(/[+-]/g, "")}${values.phone_number}`;
      this.setState({ validatingPhone: true });

      try {
        const response = await apiService.check_phone_number({
          phone_number: phoneNumber,
        });
        if (response?.is_registered) {
          setTouched({ phone_number: true }, false);
          setErrors({
            phone_number: "This phone number is already registered.",
          });
          this.setState({ validatingPhone: false });
          return;
        }
      } catch (_) {}

      this.setState({ validatingPhone: false });
    }

    this.setState({ step: this.state.step + 1 });
  };

  render() {
    const { hideDiv } = this.state;

    const SingleValue = (country_props) => (
      <components.SingleValue {...country_props}>
        {country_props.data.full.dial_code}
      </components.SingleValue>
    );

    const SelectField = (FieldProps) => (
      <Select
        className="select-field"
        placeholder={FieldProps.placeholder}
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option)
        }
      />
    );

    const CheckboxListField = (FieldProps) => (
      <Select
        className="select-field"
        placeholder="Choose your answer"
        options={FieldProps.options}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option || [])
        }
      />
    );

    const SelectCountryCodeField = (FieldProps) => (
      <Select
        className="select-field"
        options={FieldProps.options}
        {...FieldProps.field}
        components={{ SingleValue }}
        placeholder="+000"
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option)
        }
      />
    );

    const SelectStateField = (FieldProps) => (
      <Select
        className="select-field"
        placeholder={FieldProps.placeholder}
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) => this.onStateChange(option, FieldProps)}
      />
    );

    const SelectHealthlaneStoreField = (FieldProps) => (
      <Select
        className="select-field"
        placeholder={FieldProps.placeholder}
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) => this.onHealthlaneStoreChange(option, FieldProps)}
        noOptionsMessage={() =>
          FieldProps.form.values.state
            ? "No outlets available in the selected state"
            : "Please select a state to see available outlets"
        }
      />
    );

    const SelectHealthlaneDateField = (FieldProps) => (
      <Select
        className="select-field"
        placeholder={FieldProps.placeholder}
        options={FieldProps.options}
        {...FieldProps.field}
        onChange={(option) =>
          FieldProps.form.setFieldValue(FieldProps.field.name, option)
        }
        noOptionsMessage={() =>
          FieldProps.form.values.state
            ? "No options"
            : "Please select an outlet to see available appointment slots"
        }
      />
    );

    const handleScrollTotop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
      <div className="homepage">
        <RegistrationClosedModal />
        <RegistrationSuccessModal
          show={this.state.showSuccessModal}
          onHide={() => this.setState({ showSuccessModal: false })}
        />
        <div id="scrollToTop">
          <div id="scroll-to-top" onClick={handleScrollTotop}>
            <img src={scrollToTop} alt="scroll-to-top" />
          </div>
        </div>
        <section id="home">
          <div className="bg-image">
            <div className="main">
              <div className="col col-lg-6 col-12">
                <div className="main-column h-100">
                  <div className="title">
                    Sun Life Malaysia Blood Glucose <br />
                    Screening Programme 2026
                  </div>
                  <div className="sub-title">
                    Check your blood glucose levels and take a proactive step to
                    reduce your risk of diabetes with Sun Life Malaysia.
                    Available now until August 2026.
                  </div>
                  {!hideDiv && (
                    <button
                      onClick={() =>
                        document
                          .getElementById("registration-form")
                          .scrollIntoView({ behavior: "smooth" })
                      }
                    >
                      Register For Free Screenings
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        {!hideDiv && (
          <section id="registration-form">
            <div className="section-form">
              <div className="col col-lg-6 col-12">
                <div className="main-column">
                  <div className="form-step-progress mb-4 mx-auto">
                    <div
                      className="form-step-progress-bar"
                      style={{ width: `${(this.state.step / 3) * 100}%` }}
                    />
                  </div>

                  <div className="form">
                    <Formik
                      enableReinitialize
                      validationSchema={this.getValidationSchema()}
                      validateOnBlur={true}
                      validateOnChange={false}
                      validationContext={{ step: this.state.step }}
                      onSubmit={(form, actions) =>
                        this.handleRegistration(form, actions)
                      }
                      initialValues={this.state.user}
                    >
                      {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                        setTouched,
                        setErrors,
                        setFieldError,
                      }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col">
                              <div className="pb-4">
                                {this.state.step === 1 && (
                                  <>
                                    <div className="title-container pt-2 pt-lg-0">
                                      <div className="title">
                                        Register to Get Your Free Screenings
                                      </div>
                                      <div className="sub-title">
                                        Receive a complimentary Blood Glucose
                                        Test at Health Lane Family Pharmacy &
                                        6-in-1 Vision Experience Assessment at
                                        MOG Eyewear Malaysia.
                                      </div>
                                    </div>
                                    <div className="form-subtitle">Step 1</div>
                                    <div className="form-title">
                                      Fill In Your Details
                                    </div>
                                    <div className="d-flex flex-column form-inputs">
                                      <Form.Group className="">
                                        <Form.Control
                                          type="text"
                                          placeholder="Full Name As Per NRIC*"
                                          name="name"
                                          value={values.name}
                                          maxLength="100"
                                          onChange={handleChange}
                                        />
                                        <ErrorMessage
                                          component="div"
                                          name="name"
                                          className="invalid-feedback"
                                        />
                                      </Form.Group>
                                      <div className="d-flex justify-content-between">
                                        <Form.Group className="flex-fill">
                                          <Field
                                            name="age"
                                            placeholder="Age*"
                                            options={global.constant.ages}
                                            component={SelectField}
                                          />
                                          <ErrorMessage
                                            component="div"
                                            name="age"
                                            className="invalid-feedback"
                                          />
                                        </Form.Group>
                                        <Form.Group className="flex-fill ms-2">
                                          <Field
                                            name="gender"
                                            placeholder="Gender (optional)"
                                            options={global.constant.genders.filter(g => !g.hidden)}
                                            component={SelectField}
                                          />
                                          <ErrorMessage
                                            component="div"
                                            name="gender"
                                            className="invalid-feedback"
                                          />
                                        </Form.Group>
                                      </div>
                                      <Form.Group className="">
                                        <InputGroup>
                                          <Field
                                            name="country_code"
                                            options={this.state.countries}
                                            component={SelectCountryCodeField}
                                          />
                                          <FormControl
                                            aria-label="Text input with dropdown button"
                                            name="phone_number"
                                            value={values.phone_number}
                                            maxLength="15"
                                            onChange={(e) => {
                                              handleChange(e);
                                              if (errors.phone_number) {
                                                setFieldError(
                                                  "phone_number",
                                                  undefined,
                                                );
                                              }
                                            }}
                                            placeholder="Phone No*"
                                          />
                                        </InputGroup>
                                        <ErrorMessage
                                          component="div"
                                          name="phone_number"
                                          className="invalid-feedback"
                                        />
                                      </Form.Group>
                                      <Form.Group className="">
                                        <Form.Control
                                          type="email"
                                          placeholder="Email Address*"
                                          name="email"
                                          value={values.email}
                                          maxLength="50"
                                          onChange={handleChange}
                                        />
                                        <ErrorMessage
                                          component="div"
                                          name="email"
                                          className="invalid-feedback"
                                        />
                                      </Form.Group>
                                      <div className="d-flex justify-content-between">
                                        <Form.Group className="flex-fill">
                                          <Field
                                            name="state"
                                            placeholder="State"
                                            options={this.state.states}
                                            component={SelectStateField}
                                          />
                                          <ErrorMessage
                                            component="div"
                                            name="state"
                                            className="invalid-feedback"
                                          />
                                        </Form.Group>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {this.state.step === 2 && (
                                  <>
                                    <div className="form-subtitle">Step 2</div>
                                    <div className="form-title">
                                      Set Your Screening Appointment
                                    </div>
                                    <div className="d-flex flex-column">
                                      <div className="pb-2 mb-3">
                                        <div className="preferred_store_title">
                                          Health Lane Family Pharmacy*
                                        </div>
                                        <div className="d-flex flex-column form-inputs">
                                          <Form.Group className="flex-fill">
                                            <Field
                                              name="healthlane_preferred_store"
                                              placeholder="Preferred Store"
                                              options={
                                                this.state.healthlane_stores
                                              }
                                              component={
                                                SelectHealthlaneStoreField
                                              }
                                            />
                                            <ErrorMessage
                                              component="div"
                                              name="healthlane_preferred_store"
                                              className="invalid-feedback"
                                            />
                                          </Form.Group>
                                          <Form.Group className="flex-fill mb-1">
                                            <Field
                                              name="healthlane_booked_date"
                                              placeholder="Appointment Date"
                                              options={
                                                this.state
                                                  .healthlane_preferred_dates
                                              }
                                              component={
                                                SelectHealthlaneDateField
                                              }
                                            />
                                            <ErrorMessage
                                              component="div"
                                              name="healthlane_booked_date"
                                              className="invalid-feedback"
                                            />
                                          </Form.Group>
                                        </div>
                                        <span className="visit-note">
                                          *You may visit your preferred Health
                                          Lane Family Pharmacy store within its
                                          opening hours. Check your store
                                          opening hours{" "}
                                          <a
                                            href="https://bookdoc.s3.ap-southeast-1.amazonaws.com/Health+Lane+Family+Pharmacy+Participated+Stores++(+Sun+Life+Malaysia+Blood+Glucose+Screening+2026+)+-+OUTLET+DETAILS.pdf"
                                            className="link blue"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            here
                                          </a>
                                          .
                                        </span>
                                      </div>
                                      <div className="mog_container">
                                        <div className="preferred_store_title">
                                          MOG Eyewear Malaysia{" "}
                                          <span>(Optional)</span>
                                        </div>
                                        <span className="visit-note">
                                          High blood glucose can impact your
                                          vision — often without early signs.
                                          Stay ahead of potential risks with a
                                          complimentary eye screening at MOG
                                          Eyewear Malaysia today and get your
                                          eyes checked before it shows! <br />
                                          <br />
                                          <a
                                            href="https://appointment.mog.com.my/Sun-Life"
                                            className="link blue"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Book your appointment here
                                          </a>{" "}
                                          .
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {this.state.step === 3 && (
                                  <>
                                    <div className="form-subtitle">Step 3</div>
                                    <div className="form-title">
                                      Answer Survey Questions{" "}
                                    </div>
                                    {questionnaire.map((question) => (
                                      <div
                                        className="d-flex flex-column question-column"
                                        key={question.id}
                                      >
                                        <ol start={question.id}>
                                          <li className="question">
                                            {question.text}
                                            {question.id === 3 && (
                                              <span> (optional)</span>
                                            )}
                                          </li>
                                        </ol>
                                        {question.isCheckbox ? (
                                          <Field
                                            name={question.name}
                                            component={CheckboxListField}
                                            options={question.options}
                                          />
                                        ) : (
                                          <Field
                                            name={question.name}
                                            component={SelectField}
                                            placeholder="Choose your answer"
                                            options={question.options}
                                          />
                                        )}
                                        <ErrorMessage
                                          component="div"
                                          name={question.name}
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    ))}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="form-footer">
                            {this.state.step === 3 && (
                              <Form.Group>
                                <Form.Check
                                  type="checkbox"
                                  label={
                                    <span>
                                      I confirm that all the information
                                      provided is accurate and any false or
                                      misleading information may result in the
                                      denial or revocation of my registration.
                                      <br />I acknowledge and agree to the{" "}
                                      <a
                                        href={Tnc}
                                        className="link blue"
                                        download="Terms and Conditions for SLM Glucose Screening 2026"
                                      >
                                        terms and conditions
                                      </a>{" "}
                                      outlined in this form and any applicable
                                      policies.
                                    </span>
                                  }
                                  name="terms"
                                  value="true"
                                  onChange={handleChange}
                                  checked={values.terms}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="terms"
                                  className="invalid-feedback"
                                />
                              </Form.Group>
                            )}
                            <div className="d-flex justify-content-between mt-2 mt-lg-4 btn-column position-relative">
                              <Button
                                variant="secondary"
                                className="btn-register previous-btn"
                                style={{
                                  visibility:
                                    this.state.step > 1 ? "visible" : "hidden",
                                }}
                                onClick={this.goPrevStep}
                              >
                                ← Previous
                              </Button>
                              {this.state.step < 3 ? (
                                <Button
                                  variant="primary"
                                  className="btn-register yellow-btn"
                                  type="button"
                                  disabled={this.state.validatingPhone}
                                  onClick={() =>
                                    this.handleNextClick(
                                      values,
                                      setTouched,
                                      setErrors,
                                    )
                                  }
                                >
                                  {this.state.validatingPhone ? (
                                    <>
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                      />
                                      Loading...
                                    </>
                                  ) : (
                                    "Next"
                                  )}
                                </Button>
                              ) : (
                                <Button
                                  variant="primary"
                                  type="submit"
                                  className="btn-register yellow-btn submit-btn"
                                  disabled={!values.terms}
                                  id="submit-btn"
                                >
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2 d-none"
                                    id="submit-spinner"
                                  />
                                  Submit
                                </Button>
                              )}
                              <ul className="form-errors">
                                {this.state.formErrors.map((el, i) => (
                                  <li key={i}>{el}</li>
                                ))}
                              </ul>
                            </div>

                            <span className="note">
                              *This Programme is not a treatment, prevention or
                              diagnosis for any disease.
                            </span>
                          </div>
                          <ReCAPTCHA
                            ref={this._reCaptchaRef}
                            sitekey={process.env.REACT_APP_GOOGLE_API_KEY}
                            size="invisible"
                            onChange={this.handleTokenChange}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>

              <div className={`col-md-6 col form-image-col`}>
                <img
                  className="w-100 h-100 object-fit-cover"
                  src={formBanner}
                  alt="form-banner"
                />
              </div>
            </div>
          </section>
        )}
        <div className={`${hideDiv ? "" : "section-top"} section-info`}>
          {!hideDiv && (
            <section id="registration-guide">
              <div className="steps-container w-100">
                <div className="title-container">
                  <div className="title">
                    Register Now for a COMPLIMENTARY Blood Glucose Test
                  </div>
                </div>
                <div className="registration-steps">
                  <div className="step-card">
                    <div className="step-text">
                      <div className="step-number">Step 1</div>
                      <p>Complete the registration form with your details.</p>
                    </div>
                    <div className="step-image">
                      <img src={stepIconForm} alt="registration form icon" />
                    </div>
                  </div>
                  <div className="step-card">
                    <div className="step-text">
                      <div className="step-number">Step 2</div>
                      <p>
                        Visit your chosen outlet to get your COMPLIMENTARY blood
                        glucose test.
                      </p>
                    </div>
                    <div className="step-image">
                      <img src={stepIconOutlet} alt="outlet icon" />
                    </div>
                  </div>
                  <div className="step-card step-card--bonus">
                    <span className="step-badge">BONUS 1</span>
                    <div className="step-text">
                      <div className="step-number">Step 3</div>
                      <p>
                        Get a FREE 3 months Health Coaching Programme with
                        BookDoc.
                      </p>
                    </div>
                    <div className="step-image">
                      <img src={stepIconBookdoc} alt="BookDoc logo" />
                    </div>
                  </div>
                  <div className="step-card step-card--bonus">
                    <span className="step-badge">BONUS 2</span>
                    <div className="step-text">
                      <div className="step-number">Step 4</div>
                      <p>
                        Receive an instant RM10 discount from Roche Malaysia for
                        in-store purchase of the Accu-Chek® Guide Me kit.
                      </p>
                    </div>
                    <div className="step-image">
                      <img src={stepIconRoche} alt="Roche logo" />
                    </div>
                  </div>
                  <div className="step-card step-card--bonus">
                    <span className="step-badge">BONUS 3</span>
                    <div className="step-text">
                      <div className="step-number">Step 5</div>
                      <p>
                        Get a 6-in-1 Vision Experience from MOG Eyewear
                        Malaysia.
                      </p>
                    </div>
                    <div className="step-image">
                      <img src={stepIconMog} alt="MOG logo" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          <section id="bonus-rewards">
            <div className="title-container">
              <div className="title">
                <span className="bold">Three </span>Bonus Health Rewards Just
                for You
              </div>
            </div>
            <Faq />
          </section>
          <div className="title-container">
            <div className="title">
              What Sun Life Malaysia's Diabetes Programme Has Achieved
            </div>
          </div>
          <section id="stats">
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">50,000+</div>
                <div className="stat-label">screened since 2019</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">32%</div>
                <div className="stat-label">
                  identified early at the pre-diabetic or diabetic stage
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-number">1,100+</div>
                <div className="stat-label">
                  benefited from BookDoc Health Coaching Programme
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-number">57%</div>
                <div className="stat-label">
                  improvement in blood sugar levels after health coaching
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-number">87%</div>
                <div className="stat-label">
                  improvement in physical activity after health coaching
                </div>
              </div>
            </div>
          </section>
          <section id="programme-info">
            <div className="w-100">
              <img
                className="w-100 web-view img-fluid pb-12"
                src={programmeInfoImg}
                alt="programme-info"
              />
              <img
                className="w-100 mobile-view img-fluid pb-12"
                src={programmeInfoImgMobile}
                alt="mobile-banner"
              />
            </div>
          </section>
          <section id="diabetes-facts" className="pt-0">
            <img
              className="w-100 img-fluid pb-12"
              src={diabetesFactImg}
              alt="window-banner"
            />
          </section>
        </div>

        <div className="logo-container text-center">
          <div>
            <div className="content-title">Brought To You By:</div>
            <img
              src={sunlifeBizLogo}
              alt="sunlife-icon"
              className="img-fluid sunlife"
            />
          </div>
          <div className="supported-container mt-4">
            <div className="content-title">Supported By:</div>
            <div className="d-flex flex-wrap justify-content-center">
              <div className="p-2 web-view">
                <img
                  src={bookdocLogo}
                  alt="bookdoc-icon"
                  className="img-fluid"
                />
              </div>
              <div className="mobile-view">
                <img
                  src={bookdocLogoMobile}
                  alt="bookdoc-icon"
                  className="img-fluid"
                />
              </div>
              <div className="p-2 web-view">
                <img
                  src={healthlaneLogo}
                  alt="healthlane-icon"
                  className="img-fluid"
                />
              </div>

              <div className="mobile-view">
                <img
                  src={healthlaneLogoMobile}
                  alt="healthlane-icon"
                  className="img-fluid"
                />
              </div>

              <div className="p-2 web-view">
                <img src={mogLogo} alt="mog-icon" className="img-fluid" />
              </div>
              <div className="mobile-view">
                <img src={mogLogoMobile} alt="mog-icon" className="img-fluid" />
              </div>
              <div className="p-2  web-view">
                <img src={rocheLogo} alt="roche-icon" className="img-fluid" />
              </div>
              <div className="mobile-view">
                <img
                  src={rocheLogoMobile}
                  alt="roche-icon"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <span className="d-block mt-3">
            For information, please contact us at{" "}
            <a href="tel:1300882362" className="link blue">
              1300-88-2362
            </a>{" "}
            or WhatsApp{" "}
            <a href="https://wa.me/+60126442362" className="link blue">
              +6012-6442362
            </a>
            , or email us at{" "}
            <a href="mailto: care@bookdoc.com" className="link blue">
              care@bookdoc.com
            </a>
            .
          </span>
          <span className="d-block mt-3">
            *This Programme is not a treatment, prevention or diagnosis for any
            disease.
          </span>
        </div>
      </div>
    );
  }
}

export { Home };
